import { StyleSheet, Dimensions, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width, height } = Dimensions.get('window');

export default StyleSheet.create({
  backdrop: {
    width,
    height,
  },
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    marginTop: Platform.OS == 'android' ? 0 : -0.3,
  },
  modal: {
    margin: 0,
    paddingTop: 100,
  },
  lottie: {
    shadowColor: undefined,
    shadowOffset: undefined,
    shadowOpacity: undefined,
    shadowRadius: undefined,
  },
  close: {
    position: 'absolute',
    right: 16,
    top: -50,
    zIndex: 10,
  },
  tobiContainer: (theme, isVisable) => ({
    opacity: isVisable ? 1 : 0,
    alignSelf: 'center',
    backgroundColor: theme.colors.tintColor,
    borderRadius: width / 11,
    elevation: 2,
    zIndex: 10,
    height: width / 5.294,
    shadowColor: Colors.shadow,
    shadowOffset: {
      width: 0,
      height: -5,
    },
    shadowOpacity: 1,
    shadowRadius: 5,
    width: width / 5.294,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  }),
  tobiStyle: {
    width: width / 5.294,
    height: width / 5.294,
  },
});
